const debounce = require('lodash/debounce');

$(function () {
    if ($('.populate-hero-nav').length == 0 || $('#populateHeroNav').length == 0) {
        if ($('#populateHeroNav').length != 0) { $('#populateHeroNav').remove(); }
        return;
    }

    if ($('.hero-nav-item').length == 0) return;

    //used to populate the hero navigation
    populateHeroNav = {
        init: () => {
            populateHeroNav.populateDesktopHeroNav();
            $(window).on('scroll', debounce(populateHeroNav.stickDesktopHeroNav, 50));
            $(window).on("orientationchange", populateHeroNav.stickDesktopHeroNav());
        },
        populateDesktopHeroNav: () => {
            _html = '<div class="container"><ul class="landing-hero-nav my-1 my-lg-3">'
            $('.hero-nav-item').each(function () {
                _html += '<li><a href="#' + this.id.replace(/\./g, "").replace(/\?/g,"") + '" class="landing-hero-nav__link nav-link">' + $(this).attr("data-originalid").replace(/-/g, " ") + '</a></li>';
            })
            _html += '</ul></div>'
            $("#populateHeroNav").append(_html);
            $("body").attr("data-spy", "scroll");
            $("body").attr("data-target", "#populateHeroNav");
            $("body").attr("data-offset", "230");
        },
        stickDesktopHeroNav: () => {
            if ($(window).scrollTop() >= 150) {
                $("#populateHeroNav").addClass("stick-to-top");
                $("#populateHeroNav").css("top", $('.site-header').outerHeight())
            } else {
                $("#populateHeroNav").removeClass("stick-to-top");
                $("#populateHeroNav").removeAttr("style");
            }
        }
    }
    //initializing the functions
    populateHeroNav.init()
})